import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { getVideoThumbnail, removeDefaultParams } from '../../../Utils/helper';
import { Views } from '../../ArticlePage/ArticleDetail/styled';
import { Flex } from '../CategoryUserFeed/styled';
import { CardBox, TopicContent, TopicTitle } from './styled';
import Link from 'next/link';
import { ImageContainer } from '../../ArticlePage/ArticleImage/styled';

function ArticleContent(props) {
  const { content, viewsData, clickedCardEvent, outerContent } = props;
  const [views, setViews] = useState();
  //const [tagData, setTagData] = useState("");
  const isVideoArticle = outerContent?.content_type == '3';
  const router = useRouter();
  const data = () => {
    viewsData(content?.id).then((res) => {
      setViews(res);
    });
  };
  useEffect(() => {
    data();
  }, [content]);
  const tagData = () => {
    let data = '';
    const tagsWithId = content?.tagsWithId;
    const primary_tag_id = outerContent?.primary_tag_id;
    tagsWithId?.map((element) => {
      if (element?.term_id == primary_tag_id) {
        data = element?.description;
      }
    });
    return data;
  };
  return (
    <Link
      href={{
        pathname: content?.web_url,
        query: removeDefaultParams(router.query),
      }}
      passHref
      locale={false}
      legacyBehavior
    >
      <CardBox
        onClick={() => clickedCardEvent(content?.title, content?.id)}
        as="a"
      >
        {content?.webpImages?.[0] || content?.url ? (
          <div>
            {/* <TopicImage src={content?.webpImages?.[0]} alt="" /> */}
            {!isVideoArticle ? (
              <ImageContainer>
                <img
                  src={content?.webpImages?.[0]}
                  srcSet={
                    content?.webpImages?.[0]
                      ? `${content?.webpImages?.[0]}?tr=w-320,q-90 320w, ${content?.webpImages?.[0]}?tr=w-240,q-90 240w`
                      : null
                  }
                  sizes={
                    content?.webpImages?.[0]
                      ? '(max-width: 720px) 320px, 240px'
                      : null
                  }
                  alt={content?.title}
                />
              </ImageContainer>
            ) : (
              <ImageContainer>
                <img src={getVideoThumbnail(content?.url)} alt="" />
                <div className="playIcon">
                  <img src="/images/playicon.svg" alt="" />
                </div>
              </ImageContainer>
            )}
          </div>
        ) : null}

        <Flex>
          {tagData() ? <TopicTitle>{tagData()}</TopicTitle> : null}
          {views ? (
            <Flex topicNew marginLeft="auto">
              <img
                src="/images/views_eye.svg"
                alt=""
                width="16px"
                height="16px"
              />
              <Views>{views}</Views>
            </Flex>
          ) : null}
        </Flex>
        {content?.title ? (
          <TopicContent>
            <div
            // dangerouslySetInnerHTML={{
            //     __html: content?.body,
            // }}
            >
              {content?.title}
            </div>
          </TopicContent>
        ) : null}
      </CardBox>
    </Link>
  );
}

export default ArticleContent;
